import React, { useEffect } from "react";
import {
  Box,
  Paper,
  Typography,
  Grid,
  useTheme,
  alpha,
  AppBar,
  Toolbar,
  Divider,
} from "@mui/material";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { DateRangeSelector } from "../../components/DateRangeSelector/DateRangeSelector";
import dayjs, { Dayjs } from "dayjs";
import { POSDashboardCards } from "./dashboard.cards";
import { POSDashboardSales } from "./pos.dashboard.sales";
import { POSDashboardOperations } from "./pos.dashboard.operations";
import { POSDashboardMenuPerformance } from "./pos.dashboard.menu-performance";

export const DashboardPage: React.FC = () => {
  const theme = useTheme();
  const isProcessing = localStorage.getItem("paymentInProcess");
  const draftId = localStorage.getItem("DraftId");
  if (isProcessing) {
    localStorage.removeItem("paymentInProcess");
    console.log("Cleared paymentInProcess after modal close");
  }
  if (draftId) {
    localStorage.removeItem("DraftId");
    console.log("Cleared DraftId after modal close");
  }
  const [dateRange, setDateRange] = React.useState<
    [Dayjs | null, Dayjs | null]
  >([dayjs().startOf("day"), dayjs().endOf("day")]);

  useEffect(() => {
    console.log("Date range updated:", dateRange);
  }, [dateRange]);

  const renderSectionTitle = (title: string) => (
    <Box sx={{ mb: 3, mt: 4 }}>
      <Typography
        variant="h5"
        sx={{ fontWeight: 600, color: "text.primary", mb: 1 }}
      >
        {title}
      </Typography>
      <Divider />
    </Box>
  );

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        bgcolor: "background.default",
      }}
    >
      {/* AppBar */}
      <AppBar
        position="static"
        elevation={0}
        sx={{
          backgroundColor: "#1E8078",
          borderBottom: `1px solid ${alpha(theme.palette.common.white, 0.1)}`,
        }}
      >
        <Toolbar sx={{ gap: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Dashboard
          </Typography>
          <Box sx={{ flex: 1 }} />
          <DateRangeSelector
            value={dateRange}
            variant="light"
            mode="range"
            onChange={(newRange: [Dayjs | null, Dayjs | null]) => {
              if (Array.isArray(newRange) && newRange.length === 2) {
                const processedRange: [Dayjs | null, Dayjs | null] = [
                  newRange[0] ? dayjs(newRange[0]) : null,
                  newRange[1] ? dayjs(newRange[1]) : null,
                ];
                setDateRange(processedRange);
              }
            }}
          />
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Box sx={{ flex: 1, overflow: "auto" }}>
        <Box
          sx={{
            maxWidth: 1920,
            mx: "auto",
            p: 3,
          }}
        >
          {/* Key Metrics */}
          <POSDashboardCards dateRange={dateRange} />

          {/* Sales Analytics Section */}
          {renderSectionTitle("Sales Analytics")}
          <POSDashboardSales
            dateRange={dateRange}
            onDateRangeChange={setDateRange}
          />

          {/* Menu Performance Section */}
          {renderSectionTitle("Menu Performance")}
          <POSDashboardMenuPerformance dateRange={dateRange} />

          {/* Operations Section */}
          {/* {renderSectionTitle("Operations")}
          <POSDashboardOperations dateRange={dateRange} /> */}
        </Box>
      </Box>
    </Box>
  );
};
